module.exports = __webpack_public_path__ + "img/e348d5c.jpg";